<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        广东海事局局长陈毕伍一行来我司调研
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
           <div class="div-text-left news-Regular-14b6">
            <span>2020-01-09</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
        <p class="indentation">
          1月9日下午，广东海事局局长陈毕伍一行8人来大连海事大学及大连海大智龙科技有限公司调研，学校党委书记郑少南、校长孙玉清、副校长王小勇以及相关职能部门负责人、学院老师代表、海大智龙科技有限公司董事长尹勇在综合楼822会议室与陈毕伍一行进行了座谈交流。
        </p>

      </div>
      <div class="div-row div-bottom30">
        <div class="  div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news5/news1.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news5/news2.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  
  img {
    vertical-align: middle;
    border-style: none;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news5.vue